<template>
  <div class="w-full">
    <div class="sticky top-0 z-10 flex items-center justify-between h-16 px-4 bg-white border-b lg:px-6">
      <h1 class="text-lg font-bold">
        Profile
      </h1>
    </div>
    <div class="max-w-lg p-4 lg:p-6">
      <h2 class="pb-4 mb-4 text-base font-bold border-b">
        Your Details
      </h2>
      <form @submit.prevent="saveProfile">
        <fieldset class="form-group">
          <label for="name" class="form-label">Name</label>
          <input id="name" type="text" class="form-input" v-model="form.name">
          <validations :errors="errors" field="name" />
        </fieldset>
        <fieldset class="form-group">
          <label for="company" class="form-label">Company Name</label>
          <input id="company" type="text" class="form-input" v-model="form.company">
          <validations :errors="errors" field="company" />
        </fieldset>
        <fieldset class="form-group">
          <label for="email" class="form-label">Email</label>
          <input id="email" type="email" class="form-input" v-model="form.email">
          <validations :errors="errors" field="email" />
        </fieldset>
        <fieldset class="form-group">
          <label for="phone" class="form-label">Phone Number</label>
          <CellphoneInput id="phone" v-model="form.phone" @input="handlePhoneInput" />
          <validations :errors="errors" field="country" />
          <validations :errors="errors" field="phone" />
        </fieldset>
        <button class="btn btn-accent" v-submitting="submitting">
          Save Changes
        </button>
      </form>
    </div>

    <div class="max-w-lg p-4 lg:p-6">
      <h2 class="pb-4 mb-4 text-base font-bold border-b">
        Change Password
      </h2>
      <form @submit.prevent="changePassword">
        <fieldset class="form-group">
          <label for="current_password" class="form-label">Current Password</label>
          <input id="current_password" type="password" class="form-input" v-model="password.current_password">
          <validations :errors="errors" field="current_password" />
        </fieldset>
        <fieldset class="form-group">
          <label for="new_password" class="form-label">New Password</label>
          <input id="new_password" type="password" class="form-input" v-model="password.new_password">
          <validations :errors="errors" field="new_password" />
        </fieldset>
        <fieldset class="form-group">
          <label for="confirm_new_password" class="form-label">Confirm New Password</label>
          <input id="confirm_new_password" type="password" class="form-input" v-model="password.confirm_new_password">
          <validations :errors="errors" field="confirm_new_password" />
        </fieldset>
        <button class="btn btn-accent" v-submitting="submitting">
          Save Changes
        </button>
      </form>
    </div>
    
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CellphoneInput from '@/components/CellphoneInput'

export default {
  name: 'CustomerProfile',

  components: {
    CellphoneInput
  },

  created () {
    this.form = JSON.parse(JSON.stringify(this.customer))
  },

  computed: {
    ...mapState('customer', ['customer'])
  },

  data () {
    return {
      submitting: false,
      errors: [],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        country: ''
      },
      password: {
        current_password: '',
        new_password: '',
        confirm_new_password: ''
      }
    }
  },

  methods: {
    ...mapActions('customer', ['syncCustomer']),

    handlePhoneInput (number, country) {
      this.form.phone = number
      this.form.country = country.iso2
    },
    
    async saveProfile () {
      try {
        this.errors = []
        this.submitting = true
        const { data } = await this.$api.patch(`portal/${this.$store.state.portal.subdomain}/customer/profile/${this.customer.id}`, this.form)
        this.$toasted.show(`Profile Updated`)
        this.syncCustomer()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
        this.errors = error.response.data.errors ? error.response.data.errors : []
      } finally {
        this.submitting = false
      }
    },

    async changePassword () {
      try {
        this.errors = []
        this.submitting = true
        const { data } = await this.$api.patch(`portal/${this.$store.state.portal.subdomain}/customer/password/${this.customer.id}`, this.password)
        this.$toasted.show(`Password Updated`)
        this.syncCustomer()
        this.password = {
          current_password: '',
          new_password: '',
          confirm_new_password: ''
        }
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
        this.errors = error.response.data.errors ? error.response.data.errors : []
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>